import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import StyledModal from '../StyledModal';
import { useDispatch, useSelector } from 'react-redux';
import { deleteLinkage } from '../../actions/linkedAccounts';

const RevokeLinkageModal = ({ closeModal, isOpen, account }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleSubmit = useCallback(
    async (e) => {
      e.preventDefault();

      dispatch(
        deleteLinkage({
          id: account.linkage_id,
        }),
      );

      closeModal();
    },
    [dispatch, account, closeModal],
  );

  const isMinor = useSelector((state) => state?.user.is_minor);

  return (
    <StyledModal
      isOpen={isOpen}
      closeModal={closeModal}
      title={t('linkage.revoke.title', { name: account.name })}
      primaryButton={{
        text: t('linkage.revoke.button_revoke'),
        action: handleSubmit,
      }}
    >
      <p>
        {isMinor
          ? t('linkage.revoke.description_impact_self')
          : t('linkage.revoke.description_impact_other')}
      </p>
    </StyledModal>
  );
};

export default RevokeLinkageModal;
